import { notify } from 'reapop'
import { ExceptionLogsConstants } from '../constants'
import { ExceptionLogService } from '../services'

export const ExceptionLogsActions = {
    getExceptionLogs
}

function getExceptionLogs(data) {
    return dispatch => {
        dispatch(request())

        ExceptionLogService.getExceptionLogs(data)
            .then(
                verified => dispatch(success(verified)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(notify({ position: "tc", dismissible: false, message: error.toString(), status: "error" }))
                }
            )
    }

    function request() { return { type: ExceptionLogsConstants.GET_ExceptionLogs_REQUEST } }
    function success(result) { return { type: ExceptionLogsConstants.GET_ExceptionLogs_SUCCESS, result } }
    function failure(error) { return { type: ExceptionLogsConstants.GET_ExceptionLogs_FAILURE, error } }
}

